import { render, staticRenderFns } from "./AddRequestReminder.vue?vue&type=template&id=c18d0ce8&scoped=true&"
import script from "./AddRequestReminder.vue?vue&type=script&lang=js&"
export * from "./AddRequestReminder.vue?vue&type=script&lang=js&"
import style0 from "./AddRequestReminder.vue?vue&type=style&index=0&id=c18d0ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18d0ce8",
  null
  
)

component.options.__file = "AddRequestReminder.vue"
export default component.exports